<template>
  <div>
    <div class="Header">
      <div style="display: flex;">
        <div @click="openNewWindow" class="Header_logo"><img src="@a/img/logo.png" /></div>
        <!-- <div class="header_left_nav">
          <div class="left_nav_title">
            <span><img alt="logo" src="https://www.ai-dog.net/skin/images/sv16.svg" /></span>SEO软文<img alt="logo"
              src="@a/img2/sv88.svg" />
          </div>
          <div class="nav_list_down">
            <div class="list_down_padding">
              <a href="/#/ailogo/EnterBrand/EnterBrand" target="_blank" class="list_down_li">
                <div class="down_li_icon"><img src="@a/img2/sv89.svg"></div>
                <div class="down_li_title">
                  <div class="li_title_dd">LOGO创作</div>
                  <div class="li_title_dt">基于人工智能创作、海量创作高质量软文</div>
                </div>
              </a>
              <a href="/#/aicompany/CompanyHome/CompanyHome" target="_blank" class="list_down_li">
                <div class="down_li_icon"><img src="https://www.ai-dog.net/skin/images/sv26.svg"></div>
                <div class="down_li_title">
                  <div class="li_title_dd">AI公司起名</div>
                  <div class="li_title_dt">几秒内即可创建多个公司名称+查重</div>
                </div>
              </a>
              <a href="/#/copyWriting" target="_blank" class="list_down_li">
                <div class="down_li_icon"><img src="https://www.ai-dog.net/skin/images/sv17.svg"></div>
                <div class="down_li_title">
                  <div class="li_title_dd">文案创作</div>
                  <div class="li_title_dt">不再苦于写作，让AI帮你实现创意</div>
                </div>
              </a>
            </div>
          </div>
        </div> -->
      </div>
      <div class="Header_right notLogin" v-if="!this.$store.getters.isLogin" @click="toLogin">
        <div class="notLogin_icon"><img src="@a/img/sv29.svg" /></div>
        <div class="notLogin_right">
          <router-link to="/login" class="notLogin_right_btn">登录</router-link>
          <span>/</span>
          <router-link to="/login" class="notLogin_right_btn">注册</router-link>
        </div>
      </div>
      <div class="mockLoginSign" v-show="this.$store.state.IsMockLogin">当前为模拟登录用户账号，请不要做数据操作！</div>
      <div class="Header_right" v-if="this.$store.getters.isLogin">
        <!-- <a href="https://www.ai-dog.net/download/index.html" target="_blank" class="download">下载客户端</a> -->
        <div class="Header_right_con">
          <div class="Header_right_avatar"><img :src="this.baseURL + $store.getters.memberInfo.avatar" /></div>
          <div class="Header_right_txt">
            <div class="right_txt_title">{{ $store.getters.memberInfo.name }}<i class="el-icon-arrow-down"></i></div>
            <div class="WPCenter">
              <div class="WPCenter_content">
                <div class="WPCenter_top">
                  <div class="WPCenter_top_user">
                    <div class="top_user_left"><img :src="this.baseURL + $store.getters.memberInfo.avatar" /></div>
                    <div class="top_user_right">
                      <div class="user_right_dd">{{ $store.getters.memberInfo.name }}</div>
                      <div class="user_right_dt">{{ $store.getters.memberInfo.phone }}</div>
                    </div>
                  </div>
                  <div class="WPCenter_top_bottom">
                    <div class="top_bottom_dd">当前积分：{{ $store.getters.memberInfo.point_num }}</div>
                    <div @click="showWindow" class="top_bottom_dt">充值</div>
                  </div>
                  <!-- <div class="WPCenter_top_bottom">
                    <div class="top_bottom_dd">AISEO{{ $store.getters.memberInfo.seo_vip.name }}会员：{{ $store.getters.memberInfo.seo_vip.remaining_days }}天</div>
                    <div @click="clickAIPackageShow" class="top_bottom_dt">开通</div>
                  </div> -->
                </div>
                <div class="WPCenter_bottom">
                  <router-link to="/memberCentre" class="WPCenter_bottom_list"><i
                      class="el-icon-user"></i>个人中心</router-link>
                  <!-- <div class="WPCenter_bottom_list"><i class="el-icon-bell"></i>我的消息</div> -->
                  <div class="WPCenter_bottom_list" @click="logout"><i class="el-icon-switch-button"></i>退出登录</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 充值弹窗 -->
    <rechargeWindow v-if="rechargeShow" @close="rechargeShow = false"></rechargeWindow><!-- 充值弹窗 -->
    <AIPackageWindow v-if="AIPackageShow" @close="AIPackageShow = false"></AIPackageWindow>

  </div>
</template>

<script>
import { MessageBox, Message } from 'element-ui';
import rechargeWindow from "@c/common/rechargeWindow/rechargeWindow";
import AIPackageWindow from "@c/common/AIPackageWindow/AIPackageWindow";

export default {
  name: "header",
  data() {
    return {
      rechargeShow: false,
      AIPackageShow: false,
      WenJuan: true,
      adShow: false,
      adInfo: [],
    };
  },
  components: {
    rechargeWindow,
    AIPackageWindow
  },
  mounted() {
    //请求AD广告
    this.axios.get('/api/common/ad?catid=8').then(res => {
      console.log(res.result.thumb);
      if (res.result.thumb) {
        this.adShow = true;
        this.adInfo = res.result;
      }
      console.log(res.result);

    })



  },
  methods: {
    showWindow() {
      let that = this;
      that.rechargeShow = true;

    },
    clickAIPackageShow() {
      let that = this;
      that.AIPackageShow = true;

    },
    openNewWindow() {
      window.open('/', '_blank');
    },
    logout() {
      MessageBox.confirm(`确定要退出登录吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '退出成功!'
        });
        // 用户点击确定后执行删除操作
        let that = this;
        this.axios.get('/api/member/logout').then(res => {
          if (res.code === 1) {
            localStorage.removeItem('token')
            localStorage.removeItem('memberInfo')
            that.$store.commit('setLogin', false)
            that.$store.commit('setMemberInfo', {})
            this.$router.push({
              path: '/login',
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        });
        // 用户点击取消或者弹窗关闭时不做任何操作
      });
    },
    toLogin() {
      this.$router.push({
        path: '/login',
      })
    }
  }
}
</script>

<style scoped>
.CustomerService {
  position: fixed;
  right: 25px;
  bottom: 25px;
  cursor: pointer;
}

/* { animation: bounce 2s ease-in-out infinite;} */
/* @keyframes bounce {
      0% {
        transform: translateY(0);
      }
      25% {
        transform: translateY(-10px);
      }
      50% {
        transform: translateY(0);
      }
      75% {
        transform: translateY(-5px);
      }
      100% {
        transform: translateY(0);
      }
    } */
.Header {
  background: #fafbff;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 30px;
  width: calc(100% - 60px);
  position: relative;
}

.Header .Header_logo {
  cursor: pointer;
}

.Header .Header_logo img {
  height: 34px;
}

.Header .Header_right {
  display: flex;
  align-items: center;
  position: relative;
}

.Header .Header_right .Header_right_con {
  display: flex;
  align-items: center;
  position: relative;
}

.Header .Header_right .download {
  line-height: 34px;
  background: #3662eb;
  color: #fff;
  font-size: 15px;
  padding: 0px 18px;
  border-radius: 100px;
  margin-right: 20px;
}

.Header .Header_right.notLogin {
  width: 110px;
  height: 34px;
  justify-content: center;
  border-radius: 100px;
  background: #3662eb;
}

.Header .Header_right.notLogin .notLogin_icon {
  margin-right: 8px;
}

.Header .Header_right.notLogin .notLogin_icon img {
  height: 16px;
}

.Header .Header_right.notLogin .notLogin_right {
  display: flex;
  align-items: center;
}

.Header .Header_right.notLogin .notLogin_right span {
  font-size: 13px;
  color: #ffffff;
  margin: 0px 3px;
}

.Header .Header_right.notLogin .notLogin_right .notLogin_right_btn {
  font-size: 13px;
  color: #fff;
  display: flex;
  align-items: center;
}

.Header .Header_right .Header_right_con:hover .WPCenter {
  display: block;
}

.Header .Header_right .Header_right_avatar {
  width: 34px;
  height: 34px;
  border-radius: 100%;
  overflow: hidden;
  margin-right: 14px;
}

.Header .Header_right .Header_right_avatar img {
  width: 100%;
  height: 34px;
  object-fit: cover;
  border-radius: 100%;
}

.Header .Header_right .Header_right_txt .right_txt_title {
  font-size: 14px;
  color: #474b5a;
  cursor: pointer;
}

.Header .Header_right .Header_right_txt .right_txt_title i {
  margin-left: 6px;
}

.WPCenter {
  width: 267px;
  padding-top: 20px;
  position: absolute;
  right: 0px;
  top: 100%;
  display: none;
}

.WPCenter:before {
  content: "";
  width: 0;
  height: 0;
  border-right: 16px solid transparent;
  border-left: 16px solid transparent;
  border-bottom: 16px solid rgba(54, 98, 235, 1);
  position: absolute;
  top: 12px;
  right: 30px;
}

.WPCenter .WPCenter_content {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, .1);
}

.WPCenter .WPCenter_top {
  background: url("~@/assets/img/bg2.jpg") no-repeat 50%/cover;
  padding: 22px;
}

.WPCenter .WPCenter_top .WPCenter_top_user {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.WPCenter .WPCenter_top .WPCenter_top_user .top_user_left {
  width: 48px;
  height: 48px;
  border-radius: 100%;
  overflow: hidden;
  margin-right: 10px;
}

.WPCenter .WPCenter_top .WPCenter_top_user .top_user_left img {
  width: 100%;
  height: 48px;
  object-fit: cover;
}

.WPCenter .WPCenter_top .WPCenter_top_user .top_user_right .user_right_dd {
  font-size: 15px;
  color: #fff;
  font-weight: bolder;
}

.WPCenter .WPCenter_top .WPCenter_top_user .top_user_right .user_right_dt {
  font-size: 13px;
  color: #fff;
  margin-top: 7px;
}

.WPCenter .WPCenter_top .WPCenter_top_bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.WPCenter .WPCenter_top .WPCenter_top_bottom:last-child {
  margin-bottom: 0;
}

.WPCenter .WPCenter_top .WPCenter_top_bottom .top_bottom_dd {
  font-size: 13px;
  color: #fff;
}

.WPCenter .WPCenter_top .WPCenter_top_bottom .top_bottom_dt {
  font-size: 13px;
  color: #fff;
  padding: 0px 8px;
  height: 28px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3662eb;
  cursor: pointer;
}

.WPCenter .WPCenter_bottom {
  background: #fff;
}

.WPCenter .WPCenter_bottom .WPCenter_bottom_list {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #474b5a;
  cursor: pointer;
  line-height: 48px;
  padding: 0px 22px;
}

.WPCenter .WPCenter_bottom .WPCenter_bottom_list:hover {
  background: #f5f5f5;
}

.WPCenter .WPCenter_bottom .WPCenter_bottom_list:last-child {
  margin-bottom: 0;
}

.WPCenter .WPCenter_bottom .WPCenter_bottom_list i {
  margin-right: 14px;
}

.WPCenter .WPCenter_bottom .WPCenter_bottom_list i::before {
  font-size: 22px;
  color: #3662eb;
  position: relative;
  top: 1px;
}

.mockLoginSign {
  color: red;
  font-size: 16px;
  top: 0;
  font-weight: bolder;
}

.header_left_nav {
  display: flex;
  align-items: center;
  margin-left: 30px;
}

.header_left_nav {
  position: relative;
}

.header_left_nav .left_nav_title {
  display: flex;
  align-items: center;
  height: 36px;
  border-radius: 100px;
  background: linear-gradient(to left, #d437ff, #3662eb);
  color: #fff;
  padding: 0px 15px;
  cursor: pointer;
}

.header_left_nav .left_nav_title span {
  margin-right: 6px;
  font-size: 18px;
}

.header_left_nav .left_nav_title span img {
  height: 16px;
}

.header_left_nav .left_nav_title img {
  height: 5px;
  margin-left: 6px;
}

.header_left_nav .nav_list_down {
  position: absolute;
  top: 100%;
  width: 320px;
  left: 0;
  padding-top: 0px;
  display: none;
}

.header_left_nav .nav_list_down .list_down_padding {
  background: rgba(0, 0, 0, .5);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e9ecf7;
  box-shadow: 6px 4px 11px rgba(9, 24, 67, .05);
  padding: 20px 16px;
}

.header_left_nav .nav_list_down:before {
  content: "";
  width: 0;
  height: 0;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  border-bottom: 8px solid #3662eb;
  position: absolute;
  top: 12px;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: none;
}

.header_left_nav:hover .nav_list_down {
  display: block;
}

.header_left_nav .nav_list_down .list_down_li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.header_left_nav .nav_list_down .list_down_li:last-child {
  margin-bottom: 0px;
}

.header_left_nav .nav_list_down .list_down_li .down_li_icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header_left_nav .nav_list_down .list_down_li .down_li_icon img {
  height: 20px;
}

.header_left_nav .nav_list_down .list_down_li .down_li_title {
  width: calc(100% - 46px);
}

.header_left_nav .nav_list_down .list_down_li .down_li_title .li_title_dd {
  font-size: 15px;
  color: #101c3d;
  font-weight: bolder;
  margin-bottom: 6px;
}

.header_left_nav .nav_list_down .list_down_li:hover .down_li_title .li_title_dd {
  color: #3662eb;
}

.header_left_nav .nav_list_down .list_down_li .down_li_title .li_title_dt {
  font-size: 13px;
  color: #101c3d;
  margin-top: 0px;
}

.header_left_nav .nav_list_down .list_down_li:nth-child(1) .down_li_icon {
  background: linear-gradient(to right, #807fff, #3662eb);
}

.header_left_nav .nav_list_down .list_down_li:nth-child(2) .down_li_icon {
  background: linear-gradient(to right, #8d5df6, #11d6e2);
}

.header_left_nav .nav_list_down .list_down_li:nth-child(3) .down_li_icon {
  background: linear-gradient(to right, #4475eb, #5fed9b);
}

.header_left_nav .nav_list_down .list_down_li:nth-child(4) .down_li_icon {
  background: linear-gradient(to right, #11d6e2, #3662eb);
}
</style>
